// extracted by mini-css-extract-plugin
export default {"side-icon-container":"tOKt5d","sideIconContainer":"tOKt5d","title":"lm1rI4","desc":"IH_3UA"};